import React from "react";
import SeccionProducto from "../components/SeccionProducto";

export default function producto({ setUser}) {
    return (
        <>
            <SeccionProducto setUser={setUser}/>
        </>
    );
}
